<div class="container">
  <h1 class="title">{{ 'tab_info_title' | locale }}</h1>

  <div class="grid">
    <p>{{ 'createdAt' | locale }}: {{ call?.createdAt | date: "dd/MM/yyyy, HH:mm'hs'" }}</p>
    <p>{{ 'patient' | locale }}: {{ call?.patient?.name || '-' }}</p>
    @if (isBrazil) {
      <p>{{ 'id_type' | locale }}: {{ call?.patient?.documentTypeLAD || call?.patient?.documentType || '-' }}</p>
      <p>{{ 'id_number' | locale }}: {{ call?.patient?.documentNumberLAD || call?.patient?.documentNumber || '-' }}</p>
    }
    <p>
      {{ 'birth_date' | locale }}:
      {{
        patientBirthDate ? (patientBirthDate | date: 'dd/MM/yyyy') + ' (' + call?.patient?.age + ' ' + ('years_old' | locale) + ')' : '-'
      }}
    </p>
    <p>{{ 'call_provider' | locale }}: {{ call?.provider?.title || call?.provider?.name || '-' }}</p>
    <p>{{ 'motive' | locale }}: {{ call?.motive || call?.diagnosis?.motive || '-' }}</p>
    <p>{{ 'medical_history' | locale }}: {{ medicalHistory || '-' }}</p>
    @if (call?.diagnosis) {
      <p>{{ 'call_history_diagnosis' | locale }}: {{ diagnosis }}</p>
      <p>{{ 'diagnosis_text_label' | locale }}: {{ call.diagnosis.text || '-' }}</p>
    }

    @if (call?.address) {
      <p>{{ 'call_address' | locale }}: {{ call?.address || '-' }}</p>
      <p>{{ 'call_zip_code' | locale }}: {{ call?.zipCode || '-' }}</p>
    }

    @if (googleMapsUrl && !call?.address) {
      <p>
        {{ 'call_geolocation' | locale }}: <a [href]="googleMapsUrl" target="_blank">{{ googleMapsUrl }}</a>
      </p>
    }
  </div>
</div>
